import { BaseTbaParameter } from './base-tba-parameter';
import { UncontrolledTransaction } from './uncontrolled-transaction';

export class UncontrolledParameter extends BaseTbaParameter {
  uncontrolledTransaction: UncontrolledTransaction;
}
